@if ((chartInput$ | async); as chartInput) {
    <app-spider-chart [data]="chartInput.data"
                      [labels]="chartInput.labels"
                      [hideLabels]="hideLabels" />
}
